import React, { Component } from "react";
import { Button, Container, Form, Icon, Message } from "semantic-ui-react";
import Flatpickr from "react-flatpickr";
import Validator from "validatorjs";
import request from "../../utils/request";
import CheckboxFilter from "../../components/forms/elements/CheckboxFilter";

const dateTimePicker = {
  enableTime: true,
  dateFormat: "Y/m/d H:i:S",
  disableMobile: "true"
};
const resetState = () => {
  return {
    xhrStatus: "",
    xhrMessage: "",
    isLoading: false,
    campaignId: 0,
    events: [],
    formdata: {
      id: 0,
      title: "",
      start_at: "",
      end_at: "",
      status: "created",
      events: [],
      goals: {
        sales: 0,
        avg_activation: 0,
        avg_per_cap: 0,
        avg_per_seller: 0,
        avg_sale_amount: 0
      }
    }
  };
};
const statuses = [
  { key: "created", value: "created", text: "Created" },
  { key: "active", value: "active", text: "Active" },
  { key: "done", value: "done", text: "Done" },
  { key: "deleted", value: "deleted", text: "Deleted" }
];
class CampaignForm extends Component {
  constructor(props) {
    super(props);
    this.state = resetState();

    this.rules = {
      title: "required",
      start_at: "required|date",
      end_at: "required|date",
      status: "required"
    };
    //Safari and IE does not support yyyy-mm-dd format so using yyyy/mm/dd in the FE
    let formdata = this.state.formdata;
    formdata.start_at = formdata.start_at.replace(/-/g, "/");
    formdata.end_at = formdata.end_at.replace(/-/g, "/");
    this.state.validation = new Validator(formdata, this.rules);

    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount = () => {
    if (this.props.match.params.id === ":id") {
      this.props.history.replace("/campaigns");
      return;
    } else {
      this.setState({ isLoading: true });
      request
        .get(this, "api:/event", {
          sort: [{ id: "start_at", desc: true }],
          limit: 2000
        })
        .then(resp => {
          let events = [];
          resp.data.map(value => {
            return events.push({
              text: value.title,
              value: parseInt(value.id)
            });
          });
          this.setState({ events: events });
        });
      if (this.props.match.params.id > 0) {
        request.get(
          this,
          `api:/campaign/${this.props.match.params.id}`,
          {},
          this.setProfile
        );
      } else {
        this.setState({ isLoading: false });
      }
    }
  };
  componentWillUnmount = () => {
    this.setState(resetState());
  };
  handleChange = (e, { name, value }) => {
    let fd = this.state.formdata;
    fd[name] = value;
    this.setState({ formdata: fd });
  };
  handleGoals = (e, { name, value }) => {
    let fd = this.state.formdata;
    fd["goals"][name] = value;
    this.setState({ formdata: fd });
  };
  setProfile = result => {
    let profile = result;
    this.setState({
      campaignId: profile.id,
      formdata: profile,
      isLoading: false
    });
  };
  handleSubmit = () => {
    //Safari and IE does not support yyyy-mm-dd format so using yyyy/mm/dd in the FE
    let formdata = this.state.formdata;
    formdata.start_at = formdata.start_at.replace(/-/g, "/");
    formdata.end_at = formdata.end_at.replace(/-/g, "/");
    let validation = new Validator(formdata, this.rules);
    this.setState({ validation });
    if (validation.passes()) {
      this.setState({
        isLoading: true,
        xhrStatus: "",
        xhrMessage: ""
      });
      if (this.state.formdata.id === 0) {
        request.post(
          this,
          `api:/campaign`,
          this.state.formdata,
          this.saveProfile
        );
      } else {
        request.put(
          this,
          `api:/campaign/${this.props.match.params.id}`,
          this.state.formdata,
          this.saveProfile
        );
      }
    }
  };
  saveProfile = resp => {
    if (resp.status === "success" && this.state.campaignId === 0) {
      this.setState(resetState());
    }
    this.setState({
      xhrStatus: resp.status,
      xhrMessage: resp.message,
      isLoading: false
    });
  };
  render() {
    const {
      isLoading,
      xhrStatus,
      xhrMessage,
      validation,
      events,
      formdata
    } = this.state;
    return (
      <Container text>
        <Form
          id="campaignForm"
          loading={isLoading}
          success={xhrStatus === "success"}
          error={xhrStatus === "error"}
        >
          <Message success content={xhrMessage} />
          <Message error content={xhrMessage} />
          <Form.Input
            label="Title"
            name="title"
            value={formdata["title"] || ""}
            required
            error={validation.errors.has("title")}
            onChange={this.handleChange}
          />
          <Form.Field required error={validation.errors.has("start_at")}>
            <label>Start Date</label>
            <Flatpickr
              name="start_at"
              value={formdata["start_at"] || ""}
              options={dateTimePicker}
              onChange={(_, str, b) =>
                this.handleChange(b.element, { name: "start_at", value: str })
              }
            />
          </Form.Field>
          <Form.Field required error={validation.errors.has("end_at")}>
            <label>End Date</label>
            <Flatpickr
              name="end_at"
              value={formdata["end_at"] || ""}
              options={dateTimePicker}
              onChange={(_, str, b) =>
                this.handleChange(b.element, { name: "end_at", value: str })
              }
            />
          </Form.Field>
          <Form.Select
            label="Status"
            name="status"
            options={statuses}
            placeholder="Status"
            value={formdata["status"]}
            required
            error={validation.errors.has("status")}
            onChange={this.handleChange}
          />
          <Form.Field>
            <label>Event(s)</label>
            <CheckboxFilter
              name="events"
              options={events}
              value={formdata["events"]}
              onChange={this.handleChange}
            />
          </Form.Field>
          <Form.Group widths={4}>
            <Form.Input
              type="number"
              label="Total Sales (Budget)"
              name="sales"
              value={formdata["goals"]["sales"] || ""}
              error={validation.errors.has("sales")}
              onChange={this.handleGoals}
            />
            <Form.Input
              type="number"
              label="Total Expenses"
              name="expenses"
              value={formdata["goals"]["expenses"] || ""}
              error={validation.errors.has("expenses")}
              onChange={this.handleGoals}
            />
            <Form.Input
              type="number"
              label="Total Sellers"
              name="sellers"
              value={formdata["goals"]["sellers"] || ""}
              error={validation.errors.has("sellers")}
              onChange={this.handleGoals}
            />
            <Form.Input
              type="number"
              label="Total Transactions"
              name="transactions"
              value={formdata["goals"]["transactions"] || ""}
              error={validation.errors.has("transactions")}
              onChange={this.handleGoals}
            />
          </Form.Group>
          <Form.Group widths={3}>
            <Form.Input
              type="number"
              label="Avg. Per Event"
              name="avg_activation"
              value={formdata["goals"]["avg_activation"] || ""}
              error={validation.errors.has("avg_activation")}
              onChange={this.handleGoals}
            />
            <Form.Input
              type="number"
              label="Avg. Per Seller"
              name="avg_per_seller"
              value={formdata["goals"]["avg_per_seller"] || ""}
              error={validation.errors.has("avg_per_seller")}
              onChange={this.handleGoals}
            />
            <Form.Input
              type="number"
              label="Avg. Web Sale Amount"
              name="avg_sale_amount"
              value={formdata["goals"]["avg_sale_amount"] || ""}
              error={validation.errors.has("avg_sale_amount")}
              onChange={this.handleGoals}
            />
          </Form.Group>
          <Button loading={isLoading} fluid onClick={this.handleSubmit}>
            <Icon name="save" /> Submit
          </Button>
        </Form>
      </Container>
    );
  }
}

export default CampaignForm;
